import { motion } from "framer-motion";
import earth from "./earth.svg"; 
import "./EarthAnimation.css";
import "animate.css"

const EarthAnimation = ({ section }) => {
  return (
    <div id="earth-container" className="animate__animated animate__fadeInUp">
      <motion.img
        src={earth}
        alt="Earth"
        className="earth"
        animate={{ rotate: section * 90 }}
        transition={{ duration: 1 }}
      />
    </div>
  );
};

export default EarthAnimation;
